import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetAllRawMaterialApi } from "../../ApiRequests";

export const fetchRawMaterials = createAsyncThunk(
  "fetch/RawMaterials",
  async () => {
    try {
      const response = await GetAllRawMaterialApi();
      return response?.data?.data.payload;
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const RawMaterialSlice = createSlice({
  name: "RawMaterial",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRawMaterials.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchRawMaterials.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchRawMaterials.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default RawMaterialSlice.reducer;
